import { render, staticRenderFns } from "./goods-add.vue?vue&type=template&id=c6ec01ca&"
import script from "./goods-add.vue?vue&type=script&lang=js&"
export * from "./goods-add.vue?vue&type=script&lang=js&"
import style0 from "./goods-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports